const participantConstants = {
  GET_ALL_PARTICIPANTS_START: "GET_ALL_PARTICIPANTS_START",
  GET_ALL_PARTICIPANTS_SUCCESS: "GET_ALL_PARTICIPANTS_SUCCESS",
  GET_ALL_PARTICIPANTS_FAILED: "GET_ALL_PARTICIPANTS_FAILED",
  ADD_PARTICIPANT_START: "ADD_PARTICIPANT_START",
  ADD_PARTICIPANT_END: "ADD_PARTICIPANT_END",
  ADD_PARTICIPANT_FAILED: "ADD_PARTICIPANT_FAILED",
  VIEW_PARTICIPANT_START: "VIEW_PARTICIPANT_START",
  VIEW_PARTICIPANT_SUCCESS: "VIEW_PARTICIPANT_SUCCESS",
  VIEW_PARTICIPANT_FAILED: "VIEW_PARTICIPANT_FAILED",
  EDIT_PARTICIPANT_START: "EDIT_PARTICIPANT_START",
  EDIT_PARTICIPANT_END: "EDIT_PARTICIPANT_END",
  EDIT_PARTICIPANT_FAILED: "EDIT_PARTICIPANT_FAILED",
  EDIT_PARTICIPANT_SUCCESS: "EDIT_PARTICIPANT_SUCCESS",
};

export default participantConstants;
